let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b2Zjj")).then(() => parcelRequire('8pGkY'));